import { motion } from "framer-motion";

export const PageHero = ({ eyebrow, title, subtitle, image, testid }) => (
  <section data-testid={testid} className="relative pt-36 pb-16 md:pt-44 md:pb-24 overflow-hidden">
    <div className="max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-2 gap-12 items-center">
      <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}>
        <p className="text-xs uppercase tracking-[0.24em] text-sora-blue font-bold mb-4">{eyebrow}</p>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-sora-slate leading-[1.1] tracking-tight">{title}</h1>
        {subtitle && <p className="mt-6 text-lg text-sora-charcoal/75 leading-relaxed max-w-md">{subtitle}</p>}
      </motion.div>
      {image && (
        <motion.div initial={{ opacity: 0, scale: 0.96 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.9, delay: 0.15, ease: [0.22, 1, 0.36, 1] }} className="rounded-[28px] overflow-hidden shadow-[0_30px_80px_rgba(63,88,115,0.14)]">
          <img src={image} alt={title} className="w-full h-[340px] lg:h-[460px] object-cover" />
        </motion.div>
      )}
    </div>
  </section>
);
